import { render, staticRenderFns } from "./No07.vue?vue&type=template&id=b220f844&scoped=true"
import script from "./No07.vue?vue&type=script&lang=js"
export * from "./No07.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b220f844",
  null
  
)

export default component.exports